export const MODEL_IDS = Object.freeze({
  rollo: 1,
  flow: 2,
  panel: 3,
  banner: 4,
  slides: 5,
  follo: 6
});
